/* eslint-disable no-undef */
export default class Podcast {
    constructor() {
        this.canBeLoaded = true;
        this.bottomOffset = 1600;
        this.podcastTrigger = document.querySelector(".podcast-open-player");
        this.podcastsList = document.querySelector(".js--podcasts__list");
        this.podcastsLoadMoreTrigger = document.querySelector(
            ".js--podcasts__list__load-more"
        );

        this.seriesSelect = document.querySelector("#serieSelect");
        this.dateSort = document.querySelector("#sortingSelect");

        if (typeof podcastsCurrentPage !== "undefined") {
            this.podcastsCurrentPage = 1;

            this.events();
        }
    }

    events() {
        this.setCurrentPage();

        if (this.podcastsList && this.podcastsLoadMoreTrigger) {
            this.startWithObserver(this.podcastsLoadMoreTrigger, {
                rootMargin: "0px 0px 0px 0px",
            });
        }

        if (this.seriesSelect)
            this.seriesSelect.addEventListener(
                "change",
                this.changePodcastsQuery.bind(this)
            );

        if (this.dateSort)
            this.dateSort.addEventListener(
                "change",
                this.changePodcastsQuery.bind(this)
            );

        if (this.podcastTrigger) {
            this.podcastTrigger.addEventListener(
                "click",
                this.openPlayer.bind(this)
            );
        }
    }

    setCurrentPage() {
        const featuredPodcast = document.querySelector(".featured-podcast");
        const featuredPodcastId =
            featuredPodcast && featuredPodcast.getAttribute("id")
                ? featuredPodcast.getAttribute("id")
                : "";

        this.page = document.body.classList.contains("archive")
            ? "archive"
            : featuredPodcastId;
    }

    openPlayer(ev) {
        ev.preventDefault();

        const clickedTrigger = ev.currentTarget;

        if (!clickedTrigger) return;
        const podcastUrl =
            clickedTrigger.dataset.href + "?player=true&autoplay=true";

        if (!podcastUrl) return;
        window.open(
            podcastUrl,
            "targetWindow",
            `toolbar=no,
            location=no,
            status=no,
            menubar=no,
            scrollbars=yes,
            resizable=yes,
            width=SomeSize,
            height=SomeSize`
        );
    }

    startWithObserver(observedElement, observedElementOptions) {
        const current = this;
        const countersObserverOptions = observedElementOptions;
        const countersObserver = new IntersectionObserver(function (
            entries,
            observedElement
        ) {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    current.loadMorePodcasts();
                }
            });
        },
        countersObserverOptions);

        countersObserver.observe(observedElement);
    }

    loadMorePodcasts() {
        if (
            this.podcastsLoadMoreTrigger.classList.contains("disabled") ||
            !this.canBeLoaded
        )
            return;

        const selectedSeries = this.seriesSelect.value;
        const sortDate = this.dateSort.value;

        const postData = {
            action: "loadmore",
            serie: selectedSeries,
            date: sortDate,
            page: this.page,
            currentPage: this.podcastsCurrentPage,
        };

        const myUrl = new URL(__jsVarsPodcast.url.ajax);

        for (const property in postData) {
            myUrl.searchParams.append(property, postData[property]);
        }

        this.canBeLoaded = false;

        fetch(myUrl.href, {
            method: "GET",
            mode: "cors",
            cache: "no-cache",
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/json",
            },
            redirect: "follow",
            referrerPolicy: "no-referrer",
        })
            .then((resp) => resp.json())
            .then((res) => {
                if (res.success) {
                    if (!res.data || res.data === "empty") {
                        this.podcastsLoadMoreTrigger.classList.add("disabled");
                    } else if (res.data) {
                        this.podcastsCurrentPage++;
                        this.podcastsList.innerHTML += res.data;
                        this.canBeLoaded = true;
                    } else {
                        this.podcastsLoadMoreTrigger.classList.add("disabled");
                    }
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }

    changePodcastsQuery() {
        const selectedSeries = this.seriesSelect.value;
        const sortDate = this.dateSort.value;
        this.podcastsCurrentPage = 0;

        const postData = {
            action: "filter_podcasts",
            serie: selectedSeries,
            date: sortDate,
            page: this.page,
            currentPage: this.podcastsCurrentPage,
        };

        const myUrl = new URL(__jsVarsPodcast.url.ajax);

        for (const property in postData) {
            myUrl.searchParams.append(property, postData[property]);
        }

        this.canBeLoaded = false;

        fetch(myUrl.href, {
            method: "GET",
            mode: "cors",
            cache: "no-cache",
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/json",
            },
            redirect: "follow",
            referrerPolicy: "no-referrer",
        })
            .then((resp) => resp.json())
            .then((res) => {
                if (res.success) {
                    this.podcastsLoadMoreTrigger.classList.remove("disabled");

                    this.podcastsList.innerHTML = "";

                    if (!res.data || res.data === "empty") {
                        this.podcastsLoadMoreTrigger.classList.add("disabled");
                    } else if (res.data) {
                        this.podcastsList.innerHTML = res.data;
                        this.podcastsCurrentPage++;
                        this.canBeLoaded = true;
                    } else {
                        this.podcastsLoadMoreTrigger.classList.add("disabled");
                    }
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }
}
